



















import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Loader from '@/components/Loader.vue';
import { DashboardDefinition } from '@/core/interfaces/dashboardDefinition';
import DropdownMenu from '@innologica/vue-dropdown-menu';
import DashboardVehicleState from '@/components/vehicle-dashboard/DashboardVehicleState.vue';

const vehicleDashboard = namespace('vehicleDashboard');

@Component({
    components: { DashboardVehicleState, Loader, DropdownMenu },
})
export default class DashboardStatus extends Vue {
    @vehicleDashboard.State('status')
    private status!: string;

    @vehicleDashboard.State('vehicleState')
    private vehicleState!: string;

    @vehicleDashboard.State('statusTopic')
    private statusTopic!: string;

    @vehicleDashboard.State('definition')
    private definition!: DashboardDefinition;

    setStatusTopic(topic: string): void {
        this.$store.dispatch('vehicleDashboard/loadStatus', topic);
    }

    get statusTranslated(): string {
        return this.status
            .replace(/<span data-translate>(.*?)<\/span>/g, (match, key) => this.$t(key).toString());
    }
}

